import angular from 'angular';

import { createProfile } from 'ShbDeployer/hostmanagement/fdo/fdo.service';

angular.module('shbdeployer.app').controller('AddProfileController', AddProfileController);

export default function AddProfileController($scope, $async, $state, $window, ModalService, Authentication, Notifications) {
  $scope.formValues = {
    name: '',
    profileFileContent: '',
  };

  $scope.state = {
    method: 'editor',
    actionInProgress: false,
    isEditorDirty: false,
  };

  $window.onbeforeunload = () => {
    if ($scope.state.method === 'editor' && $scope.formValues.profileFileContent && $scope.state.isEditorDirty) {
      return '';
    }
  };

  $scope.$on('$destroy', function () {
    $scope.state.isEditorDirty = false;
  });

  $scope.onChangeFormValues = onChangeFormValues;

  $scope.createProfileAsync = function () {
    return $async(async () => {
      const method = $scope.state.method;

      const name = $scope.formValues.name;
      const fileContent = $scope.formValues.profileFileContent;

      if (method !== 'editor' && fileContent === '') {
        $scope.state.formValidationError = 'Содержимое файла профиля не может быть пустым';
        return;
      }

      $scope.state.actionInProgress = true;

      try {
        await createProfile(name, method, fileContent);
        Notifications.success('Профиль успешно создан');
        $scope.state.isEditorDirty = false;
        $state.go('shbdeployer.settings.edgeCompute');
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось создать профиль');
      } finally {
        $scope.state.actionInProgress = false;
      }
    });
  };

  $scope.onChangeFileContent = function onChangeFileContent(value) {
    $scope.formValues.profileFileContent = value;
    $scope.state.isEditorDirty = true;
  };

  function onChangeFormValues(newValues) {
    $scope.formValues = newValues;
  }
}
